<template>
  
  <div>
    <v-toolbar flat :class="{'dark-mode':$store.state.NightMode.sideNav == 'dark-mode','light-mode':$store.state.NightMode.sideNav == 'light-mode', 'hidden-lg-and-up': 'hidden-lg-and-up'}">
      <v-toolbar-title style="width: 260px" class="ml-0">
        <!--<v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>-->
        <span> <span style="color: orange;">MyWallet</span>Watcher</span>
      </v-toolbar-title>
    </v-toolbar>

    <!-- Side Navigation tabs -->
    <v-tabs grow color="SideNavTab">
      <v-tabs-slider color="orange"></v-tabs-slider>

      <!--Main menu-->
      <v-tab :href="'#MainMenu'" :class="{'dark-mode':$store.state.NightMode.sideNav == 'dark-mode','light-mode':$store.state.NightMode.sideNav == 'light-mode'}">
        <v-tooltip bottom>
          <v-badge slot="activator" color="green" overlap>
            <span slot="badge" v-if="mainMenuBadge !== ''"> {{ mainMenuBadge }} </span>
            <v-icon>home</v-icon>
          </v-badge>
          <span>Home</span>
        </v-tooltip>
      </v-tab>
      <!--End Of Main Menu-->

      <!--Extensions-->
      <!--<v-tab :href="'#Extensions'" :class="{'dark-mode':$store.state.NightMode.sideNav == 'dark-mode','light-mode':$store.state.NightMode.sideNav == 'light-mode'}">
        <v-tooltip bottom>
          <v-badge slot="activator" color="red" overlap>
            <span slot="badge" v-if="extensionsBadge !== ''"> {{ extensionsBadge }} </span>
            <v-icon>extension</v-icon>
          </v-badge>
          <span> Extension </span>
        </v-tooltip>
      </v-tab>-->
      <!--/Extensions-->

      <!--Budget Data-->
      <!--<v-tab :href="'#BudgetData'" :class="{'dark-mode':$store.state.NightMode.sideNav == 'dark-mode','light-mode':$store.state.NightMode.sideNav == 'light-mode'}">
        <v-tooltip bottom>
          <v-badge slot="activator" color="red" overlap>
            <span slot="badge" v-if="budgetDataBadge !== ''"> {{ budgetDataBadge }} </span>
            <v-icon>assessment</v-icon>
          </v-badge>
          <span>Budget Data</span>
        </v-tooltip>
      </v-tab>-->
      <!--Budget Data-->

      <!--Notification-->
      <!--<v-tab :href="'#Notifications'" :class="{'dark-mode':$store.state.NightMode.sideNav == 'dark-mode','light-mode':$store.state.NightMode.sideNav == 'light-mode'}">
        <v-tooltip bottom>
          <v-badge slot="activator" color="red" overlap>
            <span slot="badge" v-if="notificationBadge !== ''"> {{ notificationBadge }} </span>
            <v-icon>alarm</v-icon>
          </v-badge>
          <span> Reminder </span>
        </v-tooltip>
      </v-tab>-->

      <!-- Main Menu Tab item-->
      <v-tab-item :id="'MainMenu'">
        <v-list dense class="noPadding">
          <template v-for="item in items">
            <!--<v-layout row
            v-if="item.heading"
            align-center
            :key="item.heading">
            <v-flex xs6>
              <v-subheader v-if="item.heading">
                {{ item.heading }}
              </v-subheader>
            </v-flex>
            <v-flex xs6 class="text-xs-center">
              <a href="#!" class="body-2 black--text">EDIT</a>
            </v-flex>
          </v-layout>
          -->

            <v-list-group v-if="item.children"
                          v-model="item.model"
                          :key="item.text"
                          :prepend-icon="item.model ? item.icon : item['icon-alt']"
                          :append-icon="item.model ? item.iconend : item['iconend-alt']">
              <v-list-tile slot="activator">
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ item.text }}
                  </v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile v-for="(child, i) in item.children"
                           :key="i"
                           :to="child.link"
                           @click="">
                <v-list-tile-action v-if="child.icon" class="text-xs-center">
                  <v-icon>{{ child.icon }}</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ child.text }}
                  </v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list-group>
            <v-list-tile v-else @click="" :to="item.link" :key="item.text">
              <v-list-tile-action class="text-xs-center">
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ item.text }}
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

          </template>
        </v-list>
      </v-tab-item>
      <!-- /Main Menu Tab item-->

      <!-- Extensions Tab item-->
      <v-tab-item :id="'Extensions'">
        <template>
          <v-container fill-height>
            <v-layout justify-center align-center>
              <v-flex shrink>
                <span> No Extensions </span>
              </v-flex>
            </v-layout>
          </v-container>
        </template>
      </v-tab-item>
      <!-- /Extensions Tab item-->

      <!-- Budget Data Tab item-->
      <v-tab-item :id="'BudgetData'">
        <template>
          <v-container fill-height>
            <v-layout justify-center align-center>
              <v-flex shrink>
                <span> No Statistics </span>
              </v-flex>
            </v-layout>
          </v-container>
        </template>
      </v-tab-item>
      <!-- /Budget Data Tab item-->

      <!-- Notifications Tab item-->
      <v-tab-item :id="'Notifications'">
        <template>
          <v-container fill-height>
            <v-layout justify-center align-center>
              <v-flex shrink>
                <span> No new Notifications </span>
              </v-flex>
            </v-layout>
          </v-container>
        </template>
      </v-tab-item>
      <!-- /Notifications Tab item-->

    </v-tabs>
    <!-- /Side Navigation Tabs -->
  </div>

  
</template>

<script>
  import { sharedJS } from './sharedJS.js'

  export default {
    props: ['drawer'],
    data() {
      return {

        mainMenuBadge: '2',
        extensionsBadge: '3',
        budgetDataBadge: '1',
        notificationBadge: '2',

        navSelection: 'home',

        //side nav items
        items: [],

      }
    },
    beforeMount() {

      //Get Side Nav Items From SharedJS
      this.items = sharedJS.mainMenuItems().items

      
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/dashboard/SideNav.vue